<div>
  <h2 class="header">{{'campaigns.decline_title' | translate}}</h2>
  <p class="sub-header">{{'campaigns.decline_message' | translate}}</p>
  <div class="button-group d-flex flex-row justify-content-end">
    <button class="button gray close-btn" (click)="closeModal()">{{'common.btn.close' | translate}}</button>
    <button class="button red" (click)="onDecline()">{{'campaigns.still_decline' | translate}}</button>
    <button class="button blue" (click)="openContact()">{{'campaigns.open_contact' | translate}}</button>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/influencer-platform/influencer-details/influencer-decline-modal/influencer-decline-modal.component.html